import Swiper, {EffectCreative, Navigation, Pagination} from 'swiper';
import {Utils} from '../../common/scripts/utils';

const firstScreen = document.querySelector('.j-first-screen');
const firstSliderImage = document.querySelector('.j-first-slider');
const firstSliderText = document.querySelector('.j-first-text-slider');
const firstSliderTextParent = document.querySelector('.j-first-text-parent');
const firstSliderSubText = document.querySelector('.j-first-subtext-slider');

let textSlider = {};
let subTextSlider = {};
let imageSlider = {};

// Устанавливаем правильную высоту экрана
const setHeight = () => {
    if (firstScreen && Utils.getWindowWidth() < 1279.95) {
        firstScreen.style.height = `${window.innerHeight}px`;
    }
};

setHeight();

// Делаем правильное fade переключение у слайдера с доп текстом
const setTranslate = () => {
    const subWidth = firstSliderSubText.offsetWidth;

    for (const slide in subTextSlider.slides) {
        if (slide) {
            // Всем слайдам слайдера с субтекстом правим положение и в зависимости от их активности прячемили отображаем
            subTextSlider.slides[slide].style.transform = `translate3d(-${slide * subWidth}px, 0, 0)`;
            subTextSlider.slides[slide].style.opacity = 0;
            subTextSlider.slides[subTextSlider.activeIndex].style.opacity = 1;
        }
    }
};

// Инициализируем слайдер с крупным текстом (Строим...)
const startTextSlider = (options) => {
    if (firstSliderText) {
        const textSliderOptions = {
            modules          : [Navigation],
            init             : false,
            loop             : true,
            speed            : 800,
            spaceBetween     : 0,
            slidesPerView    : 1,
            slidesOffsetAfter: 0,
            allowTouchMove   : false,
            navigation       : {
                nextEl: '.j-first-screen-next',
                prevEl: '.j-first-screen-prev'
            },
            ...options
        };

        textSlider = new Swiper(firstSliderText, textSliderOptions);

        textSlider.init();
    }
};

// Меняем направление слайдера если это десктоп
if (Utils.getWindowWidth() > 1279.95) {
    startTextSlider({direction: 'vertical'});
} else {
    startTextSlider();
}


// Инициализируем слайдер с текстом помельче
if (firstSliderSubText) {
    const subTextSliderOptions = {
        modules             : [EffectCreative, Navigation],
        init                : false,
        loop                : true,
        speed               : 800,
        spaceBetween        : 0,
        slidesPerView       : 1,
        slidesOffsetAfter   : 0,
        allowTouchMove      : false,
        centeredSlides      : true,
        centeredSlidesBounds: true,
        navigation          : {
            nextEl: '.j-first-screen-next',
            prevEl: '.j-first-screen-prev'
        },
        effect        : 'creative',
        creativeEffect: {
            prev: {
                opacity: 0
            },
            next: {
                opacity: 0
            }
        },
        on: {
            afterInit: () => {
                // Проверяем и отображаем текст после построения слайдера
                if (firstSliderSubText.classList.contains('is-start')) {
                    setTimeout(() => {
                        firstSliderSubText.classList.remove('is-start');
                    }, 1000);
                }

                if (firstSliderTextParent && firstSliderTextParent.classList.contains('is-start')) {
                    setTimeout(() => {
                        firstSliderTextParent.classList.remove('is-start');
                    }, 1000);
                }
            }
        }
    };

    subTextSlider = new Swiper(firstSliderSubText, subTextSliderOptions);

    subTextSlider.init();

    setTranslate();
}

// Инициализируем основной слайдер с изображениями
if (firstSliderImage) {
    const imageSliderOptions = {
        modules          : [EffectCreative, Navigation, Pagination],
        init             : false,
        loop             : true,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 1,
        slidesOffsetAfter: 0,
        effect           : 'creative',
        creativeEffect   : {
            prev: {
                translate: ['-20%', 0, -1]
            },
            next: {
                translate: ['100%', 0, 0]
            }
        },
        pagination: {
            el: '.j-first-screen-pagination',

            type: 'custom',

            renderCustom(_, current, total) {
                return `<span class="slider-control__current">${current.toString().padStart(2, '0')}</span>
                           <span class="slider-control__total">/ ${total.toString().padStart(2, '0')}</span>`;
            }
        },
        navigation: {
            nextEl: '.j-first-screen-next',
            prevEl: '.j-first-screen-prev'
        },
        breakpoints: {
            1280: {
                allowTouchMove: false
            }
        }
    };

    imageSlider = new Swiper(firstSliderImage, imageSliderOptions);

    imageSlider.init();

    // Вешаем событие на смену слайду
    imageSlider.on('slideChange', () => {
        // Двигаем полоску и изменяем размер и положение картинки слайда
        if (Utils.getWindowWidth() > 1279.95) {
            const blueLine = document.querySelector('.j-first-blue-line');
            // Получаем ширину полоски
            const lineWidth = imageSlider.visibleSlides[0].dataset.width;
            // Находим текущий слайд и изображение в нем
            const image = imageSlider.slides[imageSlider.activeIndex].querySelector('img');

            // Устанавливаем ширину полоски
            blueLine.style.width = lineWidth;


            // Высчитываем куда двигать синюю боковую полоску на десктопе
            const translate = window.innerWidth - (window.innerWidth / 100 * parseInt(lineWidth));

            // Получаем требуемое расположение синей боковой полоски на десктопе
            const direction = imageSlider.visibleSlides[0].dataset.position;


            blueLine.style.transform = '';
            blueLine.style.transform = direction === 'right' ? `translateX(${translate}px)` : 'translateX(0%)';

            image.style.left = direction === 'left' ? lineWidth : '0';
            // Добавляем 10пкс для того чтобы точно не было зазора между голубой полоской и картинкой
            image.style.width = `${translate + 10}px`;
        } else {
            // На мобильных - при свайпе по картинке переключаем слайдер
            textSlider.slideTo(imageSlider.activeIndex);
            subTextSlider.slideTo(imageSlider.activeIndex);
        }

        // Запускаем правильное переключение слайдов
        setTranslate();
    });
}

window.addEventListener('resize', () => {
    if (Utils.getWindowWidth() > 1279.95 && textSlider.initialized) {
        textSlider.changeDirection('vertical');
    }

    setHeight();
});

